import React from "react";

import styled from "@emotion/styled";
import { StaticImage } from "gatsby-plugin-image";

const StyledContact = styled.section`
  position: relative;
  padding: var(--3xl) 0;

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 720px) {
      flex-direction: column;
      gap: var(--md);
    }
  }

  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: saturate(1) blur(4px);
  }

  .bg-container {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -2;
  }

  .h2 {
    margin-bottom: 0;
  }
`;

export const Contact = () => (
  <StyledContact>
    <div className="row">
      <h2 className="h2">Let's work together</h2>
      <a href="/contact" className="btn-cta">
        Contact
      </a>
    </div>
    <StaticImage src="../images/contact-bg.jpg" className="bg-container" />
  </StyledContact>
);
